import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const SponsorsBlock = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
`

export const TextContainer = styled.div`
  grid-column: 2 / 12;

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const Title = styled.h3`
  font-size: 1.6em;
  line-height: 1.4;
  margin-bottom: 10px;
  color: var(--highlight-blue);
  text-transform: uppercase;
  font-weight: bold;
`

export const Body = styled.div`
  color: var(--content-background-dark-blue);
  font-weight: 400;

  p {
    font-size: 1.4em;
    line-height: 1.357;
    color: var(--content-background-dark-blue);
    margin-bottom: 10px;
  }

  a {
    color: var(--highlight-blue);
    text-decoration-line: none;

    :hover {
      text-decoration-line: underline;
    }
  }
`

export const ItemsContainer = styled.div`
  grid-column: 2 / 12;
  margin-top: 15px;

  @media ${DEVICE.tabletL} {
    margin-top: 24px;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const Items = styled.div`
  display: flex;
  flex-direction: column;

  @media ${DEVICE.tabletL} {
    align-items: center;
    flex-flow: row wrap;
  }
`
export const Item = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  margin-bottom: 22px;

  &:last-child {
    img {
      margin-bottom: 0;
    }
  }

  @media ${DEVICE.tabletL} {
    margin-bottom: 10px;
    margin-right: 20px;

    &:last-of-type {
      margin-right: 0;
    }
  }
`

export const Image = styled.img`
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 82px;

  @media ${DEVICE.tabletL} {
    max-width: 200px;
  }
`
